import React from 'react';
import {
    TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col,
    InputGroupText, Input, InputGroup, InputGroupAddon, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle, faUsers, faEdit, faBan, faSave, faTrashAlt, faPhone, faUser } from '@fortawesome/free-solid-svg-icons';

function DivisionCard(props) {
    const contactName = `${props.division.contactFirstName || ''} ${props.division.contactLastName || ''}`;

    const defaultOptions = {
        fields: {
            divisionName: true,
            contactFirstName: true,
            contactLastName: true,
            phoneNumber: true,
            actions: true,
        },
        actions: {
            select: false,
            edit: true,
            save: true,
            cancel: true,
            delete: true,
        }
    };

    const options = { ...defaultOptions, ...props.options };

    const toggleSelect = () => {
        if (props.selected) {
            props.deselect(props.division.divisionID);
        } else {
            props.select(props.division);
        }
    };

    const update = (e) => {
        props.update(props.division.divisionID, e);
    };

    const edit = () => {
        props.edit(props.division.divisionID);
    };

    const cancel = () => {
        props.cancel(props.division.divisionID);
    };

    const save = () => {
        props.save(props.division);
    };

    const remove = () => {
        props.remove(props.division.divisionID);
    };

    return (
        <div className="card item-details">
            <div className="properties">
                {!props.isEditing && options.fields.divisionName ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faUsers} />
                        <span>{props.division.divisionName || ''}</span>
                        <div className="tooltip-target">
                            DANR Program
                        </div>
                    </div>
                ) : null}
                {!props.isEditing && options.fields.contactFirstName ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faUser} />
                        <span>{contactName}</span>
                        <div className="tooltip-target">
                            Contact
                        </div>
                    </div>
                ) : null}
                {!props.isEditing && options.fields.phoneNumber ? (
                    <div className="svg-label tooltip-parent">
                        <FontAwesomeIcon icon={faPhone} />
                        <span>{props.division.phoneNumber || ''}</span>
                        <div className="tooltip-target">
                            Phone
                        </div>
                    </div>
                ) : null}
                {props.isEditing && options.fields.divisionName ? (
                    <InputGroup className="tooltip-parent">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faUsers} /></InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Program Name" name="divisionName" value={props.division.divisionName || ''} onChange={update} />
                        <div className="tooltip-target">
                            DANR Program
                        </div>
                    </InputGroup>
                ) : null}
                {props.isEditing && options.fields.contactFirstName ? (
                    <InputGroup className="tooltip-parent">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="First Name" name="contactFirstName" value={props.division.contactFirstName || ''} onChange={update} />
                        <div className="tooltip-target">
                            First Name
                        </div>
                    </InputGroup>
                ) : null}
                {props.isEditing && options.fields.contactLastName ? (
                    <InputGroup className="tooltip-parent">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faUser} /></InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Last Name" name="contactLastName" value={props.division.contactLastName || ''} onChange={update} />
                        <div className="tooltip-target">
                            Last Name
                        </div>
                    </InputGroup>
                ) : null}
                {props.isEditing && options.fields.phoneNumber ? (
                    <InputGroup className="tooltip-parent">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><FontAwesomeIcon icon={faPhone} /></InputGroupText>
                        </InputGroupAddon>
                        <Input placeholder="Phone Number" name="phoneNumber" value={props.division.phoneNumber || ''} onChange={update} />
                        <div className="tooltip-target">
                            Phone
                        </div>
                    </InputGroup>
                ) : null}
            </div>
            {options.fields.actions ? (
                <div className="actions-horizontal">
                    {!props.isEditing && options.actions.select ? (
                        <div onClick={toggleSelect} className="action-icon">
                            <FontAwesomeIcon icon={props.selected ? faCheckCircle : faCircle} />
                        </div>
                    ) : null}
                    {!props.isEditing && window.env.user.userRoles.some(ur => [1].includes(ur.roleID)) && options.actions.edit ? (
                        <div onClick={edit} className="action-icon action-edit">
                            <FontAwesomeIcon icon={faEdit} />
                        </div>
                    ) : null}
                    {props.isEditing && window.env.user.userRoles.some(ur => [1].includes(ur.roleID)) && options.actions.cancel ? (
                        <div onClick={cancel} className="action-icon action-delete">
                            <FontAwesomeIcon icon={faBan} />
                        </div>
                    ) : null}
                    {props.isEditing && window.env.user.userRoles.some(ur => [1].includes(ur.roleID)) && options.actions.save ? (
                        <div onClick={save} className="action-icon action-add">
                            <FontAwesomeIcon icon={faSave} />
                        </div>
                    ) : null}
                    {![1 ,2, 3].includes(props.division.divisionID) && !props.isEditing && window.env.user.userRoles.some(ur => [1].includes(ur.roleID)) && options.actions.delete ? (
                        <div onClick={remove} className="action-icon action-delete">
                            <FontAwesomeIcon icon={faTrashAlt} />
                        </div>
                    ) : null}
                </div>
            ) : null}
        </div>
    );
}

export default DivisionCard;